App.directive('inputZipcode', ['$window', 'Config', '$filter', function ($window, Config, $filter) {
    return {
        restrict: 'AEC',
        scope: {
            form: '=',
            name: '@',
            placeholder: '@',
            notBorder: '=',
            notBg: '=',
            hint: '@',
            label: '@',
            value: '@',
            notAvailable: '=',
            model: '=',
            required: '=',
            pattern: '@',
            addCheck: '@',
            callback: '&'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/input-zipcode.html',
        link: function (scope) {

            scope.regex = {
                email: {
                    value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+([\.-]?\w+)*)+$/,
                    error: 'Nieprawidłowy adres e-mail'
                },
                identifier: {
                    error: 'Nieprawidłowy numer pesel'
                },
                zipcode: {
                    value: '',
                    error: 'Nieprawidłowy kod pocztowy'
                },
                birthdate: {
                    value: /[0-9]{2}[.]{1}[0-9]{2}[.]{1}[0-9]{4}/,
                    error: 'Nieprawidłowa data urodzenia (dd.mm.rrrr)'
                },
                number: {
                    value: /^\d+$/,
                    error: 'Nieprawidłowe znaki - dopuszczalne tylko cyfry'
                }
            };

            function setValidityHandler() {
                if (!scope.required) {
                    scope.regex[scope.pattern] = {};
                }
            }

            setValidityHandler();

            scope.$watchGroup(['required', 'pattern'], function () {
                setValidityHandler();
            });

            if (scope.addCheck && scope.addCheck.length) {
                scope.checkAddValid = function () {
                    if (scope.addCheck === 'identifier') {
                        var status = $filter('checkIdentifier')(scope.model);

                        if (status) {
                            scope.form[scope.name].$valid = true;
                        } else {
                            scope.form.$valid = false;
                            scope.form[scope.name].$valid = false;
                        }
                    }
                }
            }

            scope.zipCodeChange = function () {
                var callback = scope.callback || function () {
                };
                var isValid = scope.form[scope.name].$valid, toSend;
                if (scope.form[scope.name].$valid) {
                    scope.model = scope.form[scope.name].$viewValue;
                    toSend = {$event: scope.form[scope.name]};
                } else {
                    toSend = {$event: {$viewValue: null}};
                }
                console.log('[zipCodeChange]', 'isValid', isValid, 'toSend', toSend);
                callback(toSend);
            }
        }
    };
}]);
